import { collectionPath, type CollectionScope } from "./scope-url"

export const filesImportNavigationEvent = "cowork:files-import"

export function requestFilesImport() {
  window.dispatchEvent(new Event(filesImportNavigationEvent))
}

export function filesImportPath(scope: CollectionScope, requestID: string = crypto.randomUUID()) {
  const [path, search] = collectionPath("files", scope).split("?")
  const query = new URLSearchParams(search)
  query.set("import", requestID)
  return `${path}?${query}`
}
